import { useState } from "react";
import { Typography } from "@mui/material";

export const CopyableId = ({ value }: { value?: string | null }) => {
  const [copied, setCopied] = useState(false);

  if (!value) return <span>—</span>;

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    navigator.clipboard.writeText(value);
    setCopied(true);
    setTimeout(() => setCopied(false), 1000);
  };

  return (
    <Typography
      component="span"
      onClick={handleClick}
      sx={{
        fontFamily: "'JetBrains Mono', monospace",
        fontSize: "0.75rem",
        cursor: "pointer",
        color: copied ? "#34d399" : "inherit",
        "&:hover": { color: "#a78bfa" },
        transition: "color 0.15s",
      }}
    >
      {copied ? "copied" : value}
    </Typography>
  );
};
